import IosTerminal from './IosTerminal'

export default IosTerminal
